import { toTitleCase, toBool } from '@/shared/utils/mapping';
import { normalizePgTimezone } from '@/shared/utils/timezone';
import type { LoginResponseDTO } from '../dto/LoginResponseDTO';
import type { AuthSession } from '../../domain/entities/AuthSession';

export function toAuthSession(dto: LoginResponseDTO): AuthSession {
  // Prefer backend's timezone_pg, fallback to browser timezone if not provided
  const backendTimezone = dto.user.settings_user.timezone_pg;
  const timezone = backendTimezone && backendTimezone.length > 0
    ? backendTimezone
    : normalizePgTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);

  return {
    token: dto.token,
    userId: dto.user.id_user,
    firstName: toTitleCase(dto.user.first_name),
    lastName: toTitleCase(dto.user.last_name),
    email: dto.user.email.toLowerCase(),
    idPerson: dto.person.id_person,
    idEntity: dto.entity.id_entity,
    idClient: dto.id_client,
    idInstance: dto.id_instance,
    accessRoles: dto.entity.access_roles,
    isAdminDevice: toBool(dto.entity.admin_device),
    timezone,
    forceChangePassword: dto.user.force_change_password,
  };
}
